function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Row-/-Download",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Download-icon-row",
  transform: "translate(1.000000, 0.000000)",
  stroke: "#425CD4",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("line", {
  x1: 6.40142222,
  y1: 0.500666667,
  x2: 6.40142222,
  y2: 10.5006667,
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "3.20142222 7.50066667 6.40142222 10.5006667 9.60142222 7.50066667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.06808889,3 L10.6666667,3 C11.8448741,3 12.8,3.8954305 12.8,5 L12.8,13.5 C12.8,14.6045695 11.8448741,15.5 10.6666667,15.5 L2.13333333,15.5 C0.955125867,15.5 0,14.6045695 0,13.5 L0,5 C0,3.8954305 0.955125867,3 2.13333333,3 L3.73333333,3",
  id: "Path"
})));
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Row / Download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.67c3120c6df324e26f90d850516b4b1d.svg";
export { ForwardRef as ReactComponent };